import React from 'react'
import { createRoot } from 'react-dom/client'
import { AccessCodeManagementApp } from './components/App'

export let startAccessCodeManagement = (coursenum, resultsPerPage) => {
  const root = createRoot(document.getElementById('accessCodeManagementApp'))
  root.render(
    <AccessCodeManagementApp
      coursenum={coursenum}
      resultsPerPage={resultsPerPage}
    />
  )
}
